import React, { useState, useEffect } from "react";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function EditYorubaDevotional() {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [devotional, setDevotional] = useState({
    date: "",
    language: "YO",
    title: "",
    text: "",
    content: "",
    prayer: "",
    bible_reading: "",
  });

  // Fetch existing devotional data
  const fetchDevotional = async (date) => {
    try {
      const formattedDate = date.toISOString().slice(0, 10);
      const response = await axios.get(
        "https://cacityofgod.pythonanywhere.com/citizen/get_breakfastwiththeholyspirit/"
      );
      const data = response.data.find((item) => item.date === formattedDate && item.language === "YO");
      if (data) {
        setDevotional(data);
      } else {
        setDevotional({
          date: formattedDate,
          language: "YO",
          title: "",
          text: "",
          content: "",
          prayer: "",
          bible_reading: "",
        });
      }
    } catch (error) {
      console.error("Error fetching devotional:", error);
    }
  };

  // Handle input changes
  const handleChange = (e) => {
    setDevotional({ ...devotional, [e.target.name]: e.target.value });
  };

  // Submit edited devotional
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "https://cacityofgod.pythonanywhere.com/citizen/edit_yoruba_breakfastwiththeholyspirit/",
        devotional
      );
      alert("Devotional updated successfully!");
    } catch (error) {
      console.error("Error updating devotional:", error);
      alert("Failed to update devotional.");
    }
  };

  useEffect(() => {
    fetchDevotional(selectedDate);
  }, [selectedDate]);

  return (
    <div className="flex flex-col items-center min-h-screen bg-gray-100 p-6">
      <h2 className="text-2xl font-bold text-gray-900 mb-4">Edit Yoruba Devotional</h2>

      {/* Date Picker */}
      <DatePicker
        selected={selectedDate}
        onChange={(date) => setSelectedDate(date)}
        className="mb-4 p-2 border rounded-md text-gray-800"
      />

      {/* Form */}
      <form onSubmit={handleSubmit} className="bg-white shadow-md rounded-lg p-6 w-full max-w-lg">
        <div className="mb-4">
          <label className="block text-gray-700 font-bold">Title:</label>
          <input
            type="text"
            name="title"
            value={devotional.title}
            onChange={handleChange}
            className="w-full p-2 border rounded-md"
            required
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-700 font-bold">Text:</label>
          <textarea
            name="text"
            value={devotional.text}
            onChange={handleChange}
            className="w-full p-2 border rounded-md"
            required
          ></textarea>
        </div>

        <div className="mb-4">
          <label className="block text-gray-700 font-bold">Content:</label>
          <textarea
            name="content"
            value={devotional.content}
            onChange={handleChange}
            className="w-full p-2 border rounded-md"
            required
          ></textarea>
        </div>

        <div className="mb-4">
          <label className="block text-gray-700 font-bold">Prayer:</label>
          <textarea
            name="prayer"
            value={devotional.prayer}
            onChange={handleChange}
            className="w-full p-2 border rounded-md"
            required
          ></textarea>
        </div>

        <div className="mb-4">
          <label className="block text-gray-700 font-bold">Bible Reading:</label>
          <input
            type="text"
            name="bible_reading"
            value={devotional.bible_reading}
            onChange={handleChange}
            className="w-full p-2 border rounded-md"
            required
          />
        </div>

        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 transition"
        >
          Save Changes
        </button>
      </form>
    </div>
  );
}

export default EditYorubaDevotional;
